import { useQuery } from '@tanstack/react-query';
import type { VideoStoryDto } from '@pms/shared';
import { getVideoStories } from '../services/api/stories.api';

/**
 * Curated hotelier video stories (TASK-62) for the homepage band (no propertyId)
 * or a property detail page (with propertyId). Reads GET /v1/public/video-stories
 * — approved-property + active rows only. Consumers fall back to static
 * `HOTELIER_STORIES` when the result is empty or the request fails (R5).
 */
export function useVideoStories(propertyId?: string) {
  return useQuery<VideoStoryDto[]>({
    queryKey: ['video-stories', propertyId ?? 'home'],
    queryFn: () => getVideoStories(propertyId),
    staleTime: 60 * 1000,
  });
}
